import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import useAuth from "../../hooks/useAuth";

import AnalyticsHeader from "../../components/Student/Analytics/AnalyticsHeader";
import SectionView from "../../components/Student/Analytics/SectionView";

const StudentAnalyticsPage = () => {
  const { user } = useAuth();
  const [activeView, setActiveView] = useState("english"); // overall | english | math

  const pillarEstimates = user?.pillarEstimates ?? {};
  const estimateHistory = user?.estimateHistory ?? {};

  return (
    <Box>
      <AnalyticsHeader
        activeView={activeView}
        onChange={setActiveView}
      />

      {/* {activeView === "overall" && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6">
            Overall analytics coming next.
          </Typography>
        </Box>
      )} */}

      {activeView === "english" && (
        <SectionView
          section="English"
          analytics={user?.analytics?.english?.skills ?? {}}
          pillarEstimates={pillarEstimates.english ?? {}}
          estimateHistory={estimateHistory}
        />
      )}

      {activeView === "math" && (
        <SectionView
          section="Math"
          analytics={user?.analytics?.math?.skills ?? {}}
          pillarEstimates={pillarEstimates.math ?? {}}
          estimateHistory={estimateHistory}
        />
      )}
    </Box>
  );
};

export default StudentAnalyticsPage;
